module.exports = __webpack_public_path__ + "static/mouflons-257b08a6879eeb5d9397c7a4d0a5ff82.jpg";